<template>
  <b-overlay :show="plans === null" rounded="sm">
    <div v-if="plans !== null">
      <!-- Table Container Card -->
      <b-card class="mb-0">
        <h1 class="mb-2">لیست پلن ها</h1>
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <b-col
              cols="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <b-button variant="primary" @click="redirectToPlanCreate">
                <span class="text-nowrap">+ ساخت پلن جدید</span>
              </b-button>
            </b-col>
          </b-row>
        </div>

        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="plans"
          responsive
          :fields="myTableColumns"
          primary-key="id"
          show-empty
          bordered
          striped
          empty-text="موردی موجود نیست!"
        >
          <template #cell(price)="data">
            {{ Intl.NumberFormat("fa-IR").format(data.item.price) }} تومان
          </template>
          <template #cell(planType)="data">
            {{ planType[data.item.planType] }}
          </template>
          <!-- Column: delete -->

          <template #cell(delete)="data">
            <div
              class="cursor-pointer d-flex flex-row"
              v-b-modal.modal-delete
              @click="showModal(data.item.planId)"
            >
              <feather-icon size="20" icon="TrashIcon" class="text-danger" />
            </div>
          </template>

          <template #cell(edit)="data">
            <router-link
              :to="{
                name: 'apps-plans-edit',
                params: { id: data.item.planId },
              }"
              class="cursor-pointer d-flex flex-row"
            >
              <feather-icon size="20" icon="EditIcon" />
            </router-link>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
          </b-row>
        </div>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalCount"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                style="transform: rotate(180deg)"
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-card>
    </div>
    <b-modal
      id="modal-delete"
      centered
      ok-title="حذف"
      cancelTitle="انصراف"
      @ok="deletePlan(deleteItem)"
    >
      <span>حذف شود؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import PlansGetAll from "@/libs/Api/Plans/PlanGetAllRequest";
import PlansDeleteRequest from "@/libs/Api/Plans/PlanDeleteRequest";
// import BlogCategoryCreateRequest from "@/libs/Api/Blog/ProductCategoryCreateRequest";

export default {
  name: "categories-list",
  title: "دسته بندی های فیزیکی - پنل ادمین فرادیدار",
  watch: {
    currentPage: function (nv, ov) {
      this.getAllPlans(this.perPage, nv, this.searchQuery, this.perState);
    },
  },
  data() {
    return {
      planType: {
        1: "نردبان",
        2: "پکیج ثبت آگهی",
        3: "پکیج بازدید آگهی",
      },
      plans: null,
      totalCount: null,
      addNewCategory: false,
      deleteItem: null,
      currentPage: 1,
      perPage: 10,
      myTableColumns: [
        { key: "planId", label: "شناسه" },
        { key: "title", label: "نام" },
        { key: "planType", label: "نوع پلن" },
        { key: "count", label: "تعداد" },
        { key: "price", label: "قیمت" },
        { key: "delete", label: "حذف" },
        { key: "edit", label: "ویرایش" },
      ],
      defaultCreateData: {
        name: null,
        // Type 1 is for default
        // Type 2 is for anything admins added
        type: 2,
      },
    };
  },
  async created() {
    await this.getAllPlans();
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,

    vSelect,
  },
  methods: {
    redirectToPlanCreate() {
      this.$router.push({ name: "apps-plans-create" });
    },
    async getAllPlans() {
      let _this = this;

      let plansGetAll = new PlansGetAll(_this);
      plansGetAll.setParams({
        pageNumber: _this.currentPage,
        count: 10,
      });
      await plansGetAll.fetch(
        function (content) {
          _this.plans = content.plans;
          _this.totalCount = content.plansCount;
        },
        function (content) {
          console.log(content);
        }
      );
    },

    async deletePlan(param) {
      let _this = this;

      let plansDeleteRequest = new PlansDeleteRequest(_this);
      plansDeleteRequest.setId(param);
      await plansDeleteRequest.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `پلن حذف شد.`,
            },
          });
          _this.getAllPlans();
        },
        function (error) {
          console.log(error);
        }
      );
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param;
    },
  },
};
</script>

<style scoped></style>
